
































































































































import { Component, Vue} from 'vue-property-decorator';
import axios from 'axios';
import { General } from '@/services/General';
import CustomerDetails from '@/components/Net20/CustomerDetails.vue';
import { DropDownItem } from "@/services/DropDownItem";
import SearchFilter from '@/components/Utilities/SearchFilter.vue';
import LeftClickOptionMenu from "@/components/Utilities/LeftClickOptionMenu.vue";
import { i18n } from '@/i18n/i18n-setup';
import { GetDropDownListBySource, SOURCE } from '@/services/Net20DropDowns';
import { saveAs } from 'file-saver';
import { Contract } from '@/entity/Net20/Contract';
import { ContractAttachment } from '@/entity/Net20/ContractAttachment';
import { PROCESS_TYPE_ENUM } from '@/services/Enums';
import DownloadFileBackground from '../Utilities/DownloadFileBackground.vue';

@Component({
    components: {
        SearchFilter,
        CustomerDetails,
        LeftClickOptionMenu,
        DownloadFileBackground
    },
})
export default class ReportContractRenewals extends Vue {        
    idCustomerDetail: any = null;
    numericIdSelected: number = null;
    selectedContractYear: number = null;

    showLoading: boolean = false;
    ready: boolean = false;
    downloadReportInProgress: boolean = false;
    customerDetailEditMode: boolean = false;

    // advanced search
    resultsItems: any = {
        resultPage: new Array(),
        total: 0
    };
    page: number = 1;
    firstSearch: boolean = false;
    freeText = null;
    filterSelected: boolean = false;
    advCustomerId: number = null;
    advWorkshopName: string = null;
    advContractYear: string = null;
    advCustomerCountry: string = null;
    advDistributor: string = null;

    dropDownCountries: any = new Array();
    dropDownDistributor: any = new Array();
    contractYearRange: Array<number> = new Array<number>();

    searchFilters: any = null;
    downloadUrl: string = "/api/net20/DownloadReportContractRenewal"
    processDescription: string = "NET20 - Download Report Contract Agreement Renewal"
    processType: PROCESS_TYPE_ENUM = PROCESS_TYPE_ENUM.downloadFiles;

    async mounted() {
        //Recupero la lista includendo i valori dismessi per la ricerca
        this.dropDownDistributor = await General.GetDropdownList(SOURCE.DISTRIBUTOR);
        this.dropDownCountries = await this.getDropdownCountries();
        this.initContractYearRange();
        this.ready = true;
    }

    async downloadAttachment(attachmentId: string, fileName: string) {
        try {
            let response = await axios({
                method: 'get',
                url: General.GetApiUrl("/api/net20/DownloadContractAttachment?attachmentId=" + attachmentId),
                withCredentials: true,
                responseType: 'blob'
            });
            saveAs(new Blob([response.data]), fileName);
        } catch (error) {
            General.showAlertDanger(i18n.t('GENERIC.CONFIRM_DELETE_ATTACHMENT') as string, this);                               
        }
    }

    initContractYearRange(fixedYearSearch: number = 0) {
        this.contractYearRange = new Array<number>();
        if(fixedYearSearch == 0) {
            let currentYear = new Date().getFullYear();
            let lowerLimit = 3;
            let lowerLimitYear = currentYear - lowerLimit;

            for(let i = lowerLimitYear; i <= currentYear; i++) {
                this.contractYearRange.push(i);
            }
        } else {
            this.contractYearRange.push(fixedYearSearch);
        }
    }

    checkFilterParameter(){
        if(this.AdvancedSearchFilled)
            this.filterSelected = true;
        else
            this.filterSelected = false;
    }

    CheckIsNullOrEmpty(text: any) {
        if (text == null) return true;
        if (text == '') return true;
        return false;
    }

    get AdvancedSearchFilled(): boolean {      
        return this.CheckAdvancedSearchFilled();
    }

    CheckAdvancedSearchFilled(): boolean {
        if (!this.CheckIsNullOrEmpty(this.advCustomerId)) return true;     
        if (!this.CheckIsNullOrEmpty(this.advWorkshopName)) return true;
        if (!this.CheckIsNullOrEmpty(this.advContractYear)) return true;
        if (!this.CheckIsNullOrEmpty(this.advCustomerCountry)) return true;
        if (!this.CheckIsNullOrEmpty(this.advDistributor)) return true;
        return false;
    }

    CheckSearchFilled() {
        if(!this.CheckIsNullOrEmpty(this.freeText)) return true;
        if(this.CheckAdvancedSearchFilled()) return true;
        return false;     
    }

    resetFilters() {
        this.advCustomerId = null;
        this.advWorkshopName = null;
        this.advContractYear = null;
        this.advCustomerCountry = null;
        this.advDistributor = null;
        this.filterSelected = false;
    }

    formatDate(date){
        if (date==null) return '';
        return General.formatDateEng(date);

    }
    async getDropdownCountries(): Promise<Array<any>> {
        try{
            let country: DropDownItem = new DropDownItem();
            let countryList: DropDownItem[] = [];

            let response = await axios.get<any[]>(
                General.GetApiUrl('/api/net20/GetCountriesForUser'),{
                responseType: "json",
                withCredentials: true
            });
            if(response.data) {
                response.data.forEach( element => {
                    country = new DropDownItem();
                    country.idDropDownItem = element.idCountry;
                    country.itemText = element.name;

                    countryList.push(country);
                });
                return General.SetOptionsDropDown(countryList);
            }
        } catch(ex) {
            General.HandleError(ex, this);
            return null;
        }
    }
    
    resetSearch() {
        this.firstSearch = false;
        this.resultsItems.resultPage.splice(0);
        this.page = 1;
    }

    searchFilterSearchEvent(genericSearch: string) {
        if (genericSearch != null) 
            this.freeText = genericSearch;
        
        this.searchItems(true)
    }

    searchFilterResertEvent() {
        this.resetFilters()
    }

    searchItems(start: boolean) {
        if(!this.CheckIsNullOrEmpty(this.advContractYear))
            this.initContractYearRange(Number(this.advContractYear));
        else
            this.initContractYearRange();
        this.searchCustomersDo(start);
    }

    async searchCustomersDo(start: boolean) {
        this.showLoading = true;
        if (start == true)
            this.resetSearch();
        try {
            let results: any = await axios({
                method: 'post',
                url: General.GetApiUrl('/api/net20/GetReportContractRenewalWithFilterAndPaginationAsync'),
                data: {
                    FreeText: this.freeText,
                    CustomerId: this.advCustomerId,
                    WorkshopName: this.advWorkshopName,
                    ContractYear: this.advContractYear,
                    IdDistributor: this.advDistributor,
                    AllRecords: false,
                    CurrentPage: this.page,
                    ContractYearRange: this.contractYearRange,
                    IdCountry: this.advCustomerCountry
                },
                withCredentials: true,
                responseType: 'json'
            });
           
            this.resultsItems.resultPage = this.resultsItems.resultPage.concat(results.data.listPage);
            this.resultsItems.total = results.data.total;

            this.firstSearch = true;
            this.page += 1;
            
            this.showLoading = false;
        } catch (error) {
            General.HandleError(error, this);
            this.showLoading = false;
        }

    }

    getAttachmentList(contractRenewals: Array<Contract>, firstContractYear:number, firstContractYearTimespan: number, contractYear: number, id: number) {
        let attachmentList: Array<ContractAttachment> = new Array<ContractAttachment>();
        let emptyAttachment = new ContractAttachment();

        if(contractRenewals.length > 0) {
            contractRenewals.filter(x => x.contractYear == contractYear).forEach(x => {
                attachmentList = x.attachments
            });
            if(attachmentList.length == 0) {
                if(contractYear >= firstContractYear && contractYear < (firstContractYear + firstContractYearTimespan)) {
                    emptyAttachment.fileName = `${i18n.t('NET20.CONTRACT_VALID_UNTIL') as string} ${(firstContractYear + firstContractYearTimespan)}`
                    attachmentList.push(emptyAttachment);
                } else {
                    let validRenewalInYear = contractRenewals.filter(x => contractYear >= x.contractYear && contractYear < (x.contractYear + x.contractYearTimespan))[0]
                    if(validRenewalInYear != null) {
                        emptyAttachment.fileName = `${i18n.t('NET20.CONTRACT_VALID_UNTIL') as string} ${(validRenewalInYear.contractYear + validRenewalInYear.contractYearTimespan)}`
                        attachmentList.push(emptyAttachment);
                    }
                }
            }
        }
        return attachmentList;
    }

    async downloadExcelReport() {
        this.searchFilters = {
                                FreeText: this.freeText,
                                CustomerId: this.advCustomerId,
                                WorkshopName: this.advWorkshopName,
                                ContractYear: this.advContractYear,
                                IdDistributor: this.advDistributor,
                                AllRecords: true,
                                CurrentPage: this.page,
                                ContractYearRange: this.contractYearRange,
                                IdCountry: this.advCustomerCountry
                            };
       this.$bvModal.show('download-file-background');                
    }
}
